// extracted by mini-css-extract-plugin
export default {"component_ig":"Button__component_ig--ig-xtG4G"};